import { useState, useEffect } from 'react';
import axios from 'axios';
import { Navbar } from '@/components/Navbar';
import { HeroSection } from '@/components/HeroSection';
import { ServicesSection } from '@/components/ServicesSection';
import { VeluxSection } from '@/components/VeluxSection';
import { AboutSection } from '@/components/AboutSection';
import { ReferencesSection } from '@/components/ReferencesSection';
import { ContactSection } from '@/components/ContactSection';
import { Footer } from '@/components/Footer';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function HomePage() {
  const [settings, setSettings] = useState(null);
  const [services, setServices] = useState([]);
  const [references, setReferences] = useState([]);

  useEffect(() => {
    Promise.all([
      axios.get(`${API}/settings`),
      axios.get(`${API}/services`),
      axios.get(`${API}/references`)
    ]).then(([settingsRes, servicesRes, refsRes]) => {
      setSettings(settingsRes.data);
      setServices(servicesRes.data);
      setReferences(refsRes.data);
    }).catch(err => console.error('Daten laden fehlgeschlagen:', err));
  }, []);

  return (
    <div data-testid="home-page">
      <Navbar settings={settings} />
      <HeroSection settings={settings} />
      <ServicesSection services={services} />
      <VeluxSection settings={settings} />
      <AboutSection settings={settings} />
      <ReferencesSection references={references} />
      <ContactSection settings={settings} services={services} />
      <Footer settings={settings} />
    </div>
  );
}
